import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody, Progress } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMedal } from '@fortawesome/free-solid-svg-icons'
import Flex from '../../common/Flex'
import { clampPercent, formatMultiplier, formatNumber, getLevelStyle } from '../rewardsUtils'

const LevelCard = ({ summary }) => {
  const {
    level,
    next_level: nextLevel,
    xp_total: xp,
    xp_to_next_level: missingXp,
    progress_percent: progressPercent
  } = summary
  const style = getLevelStyle(level?.badge_icon)
  // El progreso y el XP faltante los calcula el backend (LevelService), así
  // la barra coincide con la app mobile.
  const percent = nextLevel ? clampPercent(progressPercent) : 100

  return (
    <Card className="h-100">
      <CardBody>
        <Flex align="center" className="mb-3">
          <div
            className="d-flex flex-center rounded-circle mr-3 flex-shrink-0"
            style={{ width: '3.5rem', height: '3.5rem', backgroundColor: style.background, color: style.color }}
          >
            <FontAwesomeIcon icon={faMedal} className="fs-3" />
          </div>
          <div className="flex-grow-1">
            <h6 className="text-600 mb-1">Tu nivel</h6>
            <h3 className="mb-0" style={{ color: style.color }}>{level?.name}</h3>
          </div>
          <span className="badge badge-soft-primary rounded-capsule fs--1 ml-2" title="Multiplicador de Coins de tu nivel">
            {formatMultiplier(level?.coin_multiplier)}
          </span>
        </Flex>

        <Flex justify="between" align="end" className="mb-1">
          <span className="fs--1 text-600">Experiencia acumulada</span>
          <span className="font-weight-semi-bold">{formatNumber(xp)} XP</span>
        </Flex>
        <Progress
          value={percent}
          className="rounded-capsule mb-2"
          style={{ height: '0.625rem' }}
          barStyle={{ backgroundColor: style.color }}
          barAriaValueText={`${Math.round(percent)}% hacia el siguiente nivel`}
        />
        <p className="fs--1 mb-0 text-600">
          {nextLevel ? (
            <>
              Te faltan <b className="text-900">{formatNumber(missingXp)} XP</b> para llegar a{' '}
              <b style={{ color: getLevelStyle(nextLevel.badge_icon).color }}>{nextLevel.name}</b>{' '}
              ({formatMultiplier(nextLevel.coin_multiplier)}).
            </>
          ) : (
            <>¡Estás en el nivel máximo! Sigue pagando puntual para conservar tus beneficios.</>
          )}
        </p>
      </CardBody>
    </Card>
  )
}

LevelCard.propTypes = { summary: PropTypes.object.isRequired }

export default LevelCard
